var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_form_3324292_000000 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.70541 10.5214H5.19497L11.6517 4.73881L11.8464 4.56479V8.38025C11.8451 9.56231 10.8875 10.5214 9.70541 10.5214ZM20.4651 25.5027L15.8606 26.668H15.8619C15.5976 26.7351 15.3179 26.6577 15.1258 26.4657C14.9324 26.2736 14.8564 25.9939 14.9221 25.7296L16.0926 21.1301C16.1274 20.996 16.197 20.8722 16.2963 20.7743L23.4259 13.642V5.74641C23.4233 4.56692 22.4669 3.61042 21.2861 3.60913H13.3931V8.3839C13.3905 10.4193 11.7406 12.0693 9.70505 12.0707H3.94556V27.2533C3.94685 28.4341 4.9046 29.3919 6.0867 29.3932H21.2862C22.4669 29.3919 23.4247 28.4341 23.426 27.2533V22.6953L20.8221 25.2992C20.7241 25.3985 20.6004 25.4692 20.4651 25.5027ZM17.5389 21.7153L16.7422 24.849L19.8798 24.055L28.0008 15.9146L25.6624 13.5749L17.5389 21.7153ZM29.7684 12.768L28.808 11.8077C28.4225 11.439 27.8154 11.439 27.4287 11.8077L26.7558 12.4819L29.0954 14.8215L29.7683 14.1473C29.9514 13.9643 30.0545 13.7168 30.0545 13.4577C30.0545 13.1986 29.9514 12.9511 29.7684 12.768Z",
    fill: "#A7A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.864f3251c5c030aedc3f0ce435f77b78.svg";
export { ForwardRef as ReactComponent };